import {
    getWithdrawalPageListApi,
    updateWithdrawalRejectApi,
    updateWithdrawalPassApi,
    queryPaymentStatus, queryZjyzBalance
} from "@/api/WithdrawalApplicationApi";
import sd from "silly-datetime";

export const mixins = {
    data() {
        return {
            tableData: [],
            listParams: {
                current: 1,
                size: 10,
                name: "",
                type: "1",
                startCreateTime: '',
                endCreateTime: '',
                status: "",
                userId: ""
            },
            tableDataTotal: 0,
            balance: '',
            options: [
                {
                    value: '0',
                    label: '待审核'
                }, {
                    value: '1',
                    label: '已打款'
                }, {
                    value: '2',
                    label: '已驳回'
                }, {
                    value: '3',
                    label: '打款中'
                }, {
                    value: '4',
                    label: '打款失败'
                }],
            dateValue: "",
            orders: [],
            withdrawVisible: false,
            showRejectVisible: false,
            rejectId: null,
            rejectReason: ""
        }
    },
    methods: {
        downloadInvoice(url) {
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        openOrders(item) {
            this.orders = JSON.parse(item)
            this.withdrawVisible = true

        },
        async getWithdrawalPageList() {
            if (this.dateValue) {
                this.listParams.startCreateTime = sd.format(this.dateValue[0], 'YYYY-MM-DD HH:mm:ss')
                this.listParams.endCreateTime = sd.format(this.dateValue[1], 'YYYY-MM-DD') + " 23:59:59"
            }

            let {data} = await getWithdrawalPageListApi(this.listParams)
            this.tableData = data.rows
            this.tableDataTotal = data.total
            if (this.listParams.type == 1) {
                const res = await queryZjyzBalance();
                this.balance = res.data;
            }
        },
        handleSizeChange(val) {
            this.listParams.size = val
            this.getWithdrawalPageList()
        },
        handleCurrentChange(val) {
            this.listParams.current = val
            this.getWithdrawalPageList()
        },
        clearParams() {
            this.dateValue = ""
            this.listParams = {
                current: 1,
                size: 10,
                name: "",
                startCreateTime: '',
                endCreateTime: '',
                status: "",
                userId: ""
            }
        },
        async pass(id) {
            this.$confirm(this.listParams.type == 1 ? '确定发起灵工打款吗？' : '确定已经线下公对公打款了吗？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(async () => {
                await updateWithdrawalPassApi({id: id})
                this.$message.success("审核成功")
                this.getWithdrawalPageList()
            })
        },
        async reject() {
            await updateWithdrawalRejectApi({id: this.rejectId, remark: this.rejectReason})
            this.$message.success("审核成功")
            this.getWithdrawalPageList()
            this.closeRejectDialog();
        },
        showReject(id, remark) {
            this.showRejectVisible = true;
            this.rejectId = id;
            this.rejectReason = remark;
        },
        closeRejectDialog() {
            this.showRejectVisible = false;
            this.rejectId = "";
            this.rejectReason = "";
        },
        async searchResult(id) {
            await queryPaymentStatus({id: id});
            this.getWithdrawalPageList()
        }
    },
    created() {
        this.getWithdrawalPageList()
    }
}
